export const API_URL: string = 'https://service.grupoaaf.com.ar/web';
//version 1.0
